// sections/SectionEmploymentStudy.jsx
import React from 'react';
import { Briefcase } from 'lucide-react';
import { Row, Col, Select, SectionTitle, FormField } from '../../../SharedInputs.jsx';
import { EMPLOYMENT_STATUSES, STUDY_REASONS } from '../../../../constants.js';

export function SectionEmploymentStudy({ value, onChange, errors = [] }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div>
      <SectionTitle icon={Briefcase} step={9}>Employment & Study Motivation</SectionTitle>
      
      <Row>
        <Col>
          <FormField label="Current employment status"
          hint={"For casual, seasonal, contract and shift work, use the current number of hours worked per" +
            "week to determine whether full time (35 hours or more per week) or part-time employed (less than 35 hours per week). "}>
            <Select value={value.employmentStatus} onChange={(e) => updateField('employmentStatus', e.target.value)}>
              <option value="">Select employment status</option>
              {EMPLOYMENT_STATUSES.map(status => (
                <option key={status} value={status}>{status}</option>
              ))}
            </Select>
          </FormField>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormField label="Main reason for undertaking this course">
            <Select value={value.studyReason} onChange={(e) => updateField('studyReason', e.target.value)}>
              <option value="">Select study reason</option>
              {STUDY_REASONS.map(reason => (
                <option key={reason} value={reason}>{reason}</option>
              ))}
            </Select>
          </FormField>
        </Col>
      </Row>
    </div>
  );
}